import Vue from 'vue'
import state from 'lib/appState'
import 'modules/content-drawer/content-drawer.vue'
import SearchResults from 'modules/search-results/search-results.vue'

export default el => new Vue({
  el,
  data () {
    return {
      state
    }
  },
  components: {
    SearchResults
  },
  mounted () {
  },
  methods: {}
})
